import { render, staticRenderFns } from "./JointUser.vue?vue&type=template&id=2f8ef827&"
import script from "./JointUser.vue?vue&type=script&lang=js&"
export * from "./JointUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports